import {useEffect} from "react";
import {Outlet, useLocation} from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import styles from './Layout.module.scss';
import PreFooter from "../PreFooter/PreFooter";
import BottomNav from "../BottomNav/BottomNav";

function Layout() {
    const location = useLocation();

    useEffect(() => {
        if (!location.hash) return;

        const id = decodeURIComponent(location.hash.slice(1));

        // Ждем рендер секции (особенно важно при переходе на главную с #tag)
        requestAnimationFrame(() => {
            document.getElementById(id)?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        });
    }, [location.pathname, location.hash]);

    return (
        <div className={`${styles.layoutContainer}`}>
            <Header/>
            <main className={`${styles.layoutContent}`}>
                <Outlet/>
            </main>
            <BottomNav/>
            <PreFooter/>
            <Footer/>
        </div>
    );
}

export default Layout;
